import { Button, SheetHeader, SheetTitle } from '@folio/components';
import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export function DrawerPanel({
  title,
  onBack,
  isBackDisabled = false,
  children,
}: {
  title: string;
  onBack?: () => void;
  isBackDisabled?: boolean;
  children: ReactNode;
}) {
  const { t } = useTranslation();

  return (
    <>
      <SheetHeader className="flex-row items-center gap-2 space-y-0 border-b py-3 pl-5 pr-12">
        {onBack && (
          <Button
            variant="ghost"
            size="xs"
            aria-label={t('connectedEmailAccounts.funnel.back')}
            onClick={onBack}
            disabled={isBackDisabled}
            className="size-7 p-0"
          >
            <ArrowLeft className="size-4" />
          </Button>
        )}
        <SheetTitle className="text-base">{title}</SheetTitle>
      </SheetHeader>
      <div className="flex-1 overflow-y-auto p-5">{children}</div>
    </>
  );
}
